export class FeatureIntroductionVersionPresenter {
    constructor(platform) {
        this.iOS = platform.iOS
        this.android = platform.android
    }
}



// WEBPACK FOOTER //
// ./src/presenters/featureIntroduction/FeatureIntroductionVersionPresenter.js